import React, { useMemo } from 'react';
import { FlexSectionContainer } from "components/layout"
import { Chart, WithLoadingComponent, SVGLoader } from "components/shared";
import { ReportingService } from 'services/http';
import Utils, { REPORTING_ENDPOINTS_SUFFIXES } from "utils";

export const DurationKpiTemplate = (props) => {

    const { data, templates } = props;
    const metaRows = data.map(item => item.dataModel.map(model => model.dataName))[0];
    const rows = data.map(item => item.dataModel.map(model => model.dataValue))
    const rowsT = rows[0].map((_, colIndex) => rows.map(row => row[colIndex]))
    const filterSearchParam = JSON.parse(new URLSearchParams(window.location.search).get("filter"));

    const chartOptions = () => {
        let series = [data.find(item => item.status === templates[0])["dataModel"], data.find(item => item.status === templates[1])["dataModel"]];
        return {
            chart: {
                height: 450,
                type: "bar",
            },
            title: {
                text: "Chart presentation"
            },
            credits: {
                enabled: false
            },
            series: [{
                name: templates[0],
                data: series[0].map(item => { return { name: item.dataName, y: item.dataValue } })
            },
            {
                name: templates[1],
                data: series[1].map(item => { return { name: item.dataName, y: item.dataValue } })
            }],
            xAxis: {
                categories: series[0].map(item => {
                    return item.dataName
                })
            },
            yAxis: {
                title: {
                    text: "Nbr interventions"
                }
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            legend: {
                enabled: true,
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'top',
                x: -40,
                y: 80,
                floating: true,
                borderWidth: 1,
                backgroundColor: '#FFFFFF',
                shadow: true
            },
            tooltip: {
                headerFormat: '<span style="font-size:11px">{point.name}</span><br>',
                pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b> <br/>'
            }
        }
    }

    return (
        <FlexSectionContainer title="Nbr Interventions by delay">
            <div style={{ width: "40%" }}>
                <DataTable
                    title={"Intervention status"}
                    columns={["time range"].concat(data.map(item => item.status))}
                    metaRows={metaRows}
                    rows={rowsT}
                />
            </div>
            <div style={{ width: "60%" }}>
                <Chart
                    options={chartOptions()}
                    downloadReport={(type) => ReportingService.downloadKpiReport(REPORTING_ENDPOINTS_SUFFIXES.QUALITY_INTERVENTION_DELAY, Utils.buildFilterCriteria(filterSearchParam), type)} />
            </div>
        </FlexSectionContainer>
    )
}

export const CustomDurationKPIHoc = (props) => {
    const CustomKPIHoc = useMemo(() => WithLoadingComponent(DurationKpiTemplate, props.httpService, <SVGLoader label="Loading..." />)(props), []);
    return <CustomKPIHoc />
}

export const DataTable = (props) => {
    const { title, columns, rows, metaRows } = props;
    return <table>
        <thead>
            <tr>
                <th></th>
                <th className="h-title" colspan="2"><pre className="m-0">{title}</pre></th>
            </tr>
            <tr>
                {columns.map(column => <th className="h-column">{column}</th>)}
            </tr>
        </thead>
        <tbody>
            {
                rows.map((items, index) => <tr>
                    {<td>{metaRows[index]}</td>}
                    {items.map(item => <td>{item}</td>)}
                </tr>)
            }
        </tbody>
    </table >
}
